import React from 'react'
import { withRouter } from 'react-router-dom'
import { message, Tabs } from 'antd'
import DayTable from './component/dayTable/dayTable'
import MonthTable from './component/monthTable/monthTable'
import FakeAttendance from './component/fakeAttendance/fakeAttendance'
import './index.css'
import { attendanceAllReview } from '../../api/employee'

const { TabPane } = Tabs

class ClubAttendanceRecord extends React.Component {
  state = {
    key: '1',
    fakeLoading: false,
    fakeList: [],
  }
  componentDidMount() {}

  callback = (key) => {
    if (this.state.fakeLoading) {
      return
    }
    this.setState({ key })
    if (key == 3) {
      console.log('补卡审核')
      this.getFekeDatas()
    }
  }

  // 获取审核列表
  getFekeDatas = async () => {
    this.setState({
      fakeLoading: true,
    })
    const { status, detail, data } = await attendanceAllReview()
    this.setState({
      fakeLoading: false,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
      const newData = dataAry.map((item) => {
        const { employee, apply, detail } = item
        return {
          createTime: apply.createTime,
          id: apply.id, // 申请记录ID
          type: apply.type, // 申请类型：1.迟到补卡，2.早退补卡，3.缺勤补卡，4.请假，5.加班，6.地址异常补卡
          startTime: apply.startTime, // 开始时间
          endTime: apply.endTime, // 结束时间
          duration: apply.duration, // 时长
          content: apply.content, // 理由
          attachedFileUrl: apply.attachedFileUrl, // 附加图片

          name: employee.name, // 员工名称
          state: detail ? detail.state : 1, // 打卡状态：1.完成，2.迟到，3.早退，4.地位地址异常，5.缺勤，6.请假
          clockTime: detail ? detail.clockTime : '', // 打卡时间
          position: detail ? detail.position : '', // 地址
          normalClockTime: detail ? detail.normalClockTime : '', // 补卡时间
        }
      })
      this.setState({
        fakeList: newData,
      })
    } else {
      this.setState({
        fakeList: [],
      })
    }
  }

  onRequest = (flag) => {
    this.setState({
      fakeLoading: flag,
    })
  }

  render() {
    const { fakeLoading, fakeList } = this.state
    return (
      <Tabs activeKey={this.state.key} onChange={this.callback}>
        <TabPane tab="按日查看" key="1">
          <DayTable />
        </TabPane>
        <TabPane tab="月度统计" key="2">
          <MonthTable />
        </TabPane>
        <TabPane tab="假勤补卡审核" key="3">
          <FakeAttendance
            isLoading={fakeLoading}
            list={fakeList}
            requestEvent={this.onRequest}
            refreshList={this.getFekeDatas}
          />
        </TabPane>
      </Tabs>
    )
  }
}

export default withRouter(ClubAttendanceRecord)



// WEBPACK FOOTER //
// ./src/containers/ClubAttendanceRecord/index.js